import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { UnallocatedSalesLeadsDataGrid } from "src/components/views/erp/sales/crm/unallocatedSalesLeads/UnallocatedSalesLeadsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/crm/incomingLeads")({
	staticData: { title: i18n.t("incoming_leads"), legacyViewKey: "unallocatedSalesLeadsView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <UnallocatedSalesLeadsDataGrid />;
}
